/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import { Icon, Size } from '@vaisala-rockhopper/components';
import { VaiIcon } from '@vaisala-rockhopper/design-tokens';
import IconButton from './IconButton';
import { Tooltip, TooltipProps } from './Tooltip';

export interface InfoButtonProps extends TooltipProps {
  onButtonClick?: () => void;
}

const InfoButton = ({ tooltip, hPos, vPos, onButtonClick }: any) => (
  <IconButton onButtonClick={onButtonClick} className="info-button tooltip" buttonSize={Size.M} startIcon={<Icon name={VaiIcon.HelpO} />}>
    {tooltip && <Tooltip tooltip={tooltip} hPos={hPos} vPos={vPos} />}
  </IconButton>
);

export default InfoButton;
